// 8.3.11 Video Moments UI (merged as `vm`).
const vm = {
 "label": "Eine Situation für dich",
 "play": "Abspielen",
 "pause": "Pause",
 "replay": "Nochmal ansehen",
 "showTranscript": "Transkript zeigen",
 "hideTranscript": "Transkript ausblenden",
 "showMeaning": "Bedeutung zeigen",
 "hideMeaning": "Bedeutung ausblenden",
 "whatWouldYouSay": "Was würdest du sagen?",
 "placeholder": "Antworte auf {lang}",
 "respond": "Antworten",
 "natural": "Das klingt natürlich.",
 "better": "Natürlicher wäre vielleicht:",
 "savePhrase": "Ausdruck speichern",
 "saved": "Gespeichert",
 "usefulPhrases": "Nützliche Ausdrücke",
 "continueFriend": "Weiter in Fluent Friend",
 "openInterview": "Ein ganzes Interview üben",
 "startMission": "Mission starten",
 "videoFailed": "Das Video konnte nicht laden – du kannst die Szene trotzdem lesen und antworten.",
 "respondFailed": "Senden hat nicht geklappt – versuch es nochmal.",
 "retryVideo": "Video erneut laden",
 "recommendedLevel": "Empfohlenes Niveau",
 "video": "Videoszene",
 "titles": {"vm_cafe_es": "Im Café bestellen", "vm_hotel_fr": "Hotelrezeption", "vm_meet_de": "Jemanden kennenlernen", "vm_interview_ar": "Beginn eines Vorstellungsgesprächs", "vm_directions_sr": "Nach dem Weg fragen", "vm_disagree_sr": "Eine kleine Meinungsverschiedenheit"},
 "roles": {"waitress": "Kellnerin", "customer": "Gast", "receptionist": "Rezeptionistin", "guest": "Hotelgast", "interviewer": "Interviewer", "candidate": "Bewerber", "tourist": "Tourist", "passer-by": "Passantin"}
};
export default vm;
